export enum TipoContaEnum {
    ContaAPagar = 1,
    ContaAReceber = 2
}
